module.exports = __webpack_public_path__ + "static/img/snes.b187ca6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/snes.png
// module id = 0nB3
// module chunks = 2